export default "__VITE_ASSET__COwyvatU__"